import { useQuery } from '@tanstack/react-query'

import { useAdminApi } from '@app/api/api-client-context'
import { unwrapApiResponse } from '@shared/api'
import type { ExerciseTaxonomies } from './model'

export const exerciseKeys = {
	all: ['admin', 'exercises'] as const,
	list: (filters: Record<string, unknown>) => [...exerciseKeys.all, 'list', filters] as const,
	detail: (id: string) => [...exerciseKeys.all, 'detail', id] as const,
	taxonomies: ['admin', 'exercise-taxonomies'] as const,
}

export const useExerciseTaxonomies = () => {
	const api = useAdminApi()
	return useQuery({
		queryKey: exerciseKeys.taxonomies,
		queryFn: async (): Promise<ExerciseTaxonomies> => {
			const [muscles, difficulties, equipment, types] = await Promise.all([
				api.GET('/admin/v1/taxonomies/muscles'),
				api.GET('/admin/v1/taxonomies/difficulties'),
				api.GET('/admin/v1/taxonomies/equipment'),
				api.GET('/admin/v1/taxonomies/exercise-types'),
			])
			return {
				muscles: unwrapApiResponse(muscles).data,
				difficulties: unwrapApiResponse(difficulties).data,
				equipment: unwrapApiResponse(equipment).data,
				types: unwrapApiResponse(types).data,
			}
		},
		staleTime: 5 * 60_000,
	})
}
